<script>
  import { auth } from '../../state/auth.svelte.js';
  import { getCatalogModel } from '../../state/model-catalog.svelte.js';
  import { getImageModelCoverage } from '../../utils/image-model-catalog.js';
  let { selectedIds = [], promptCount = 1, imagesPerModel = 4, showTotal = true } = $props();
  const coverage = $derived(selectedIds.map(id => getImageModelCoverage(getCatalogModel(id), auth.isUnlimited)));
  const covered = $derived(coverage.filter(value => value === 'covered').length);
  const credits = $derived(coverage.filter(value => value === 'credits').length);
  const unknown = $derived(coverage.filter(value => value === 'unknown').length);
  const total = $derived(promptCount * selectedIds.length * Number(imagesPerModel));
</script>

<div class="render-summary" role="status" aria-live="polite">
  {#if showTotal}<strong>{total} {total === 1 ? 'image' : 'images'} total</strong>
  <span>{promptCount} {promptCount === 1 ? 'prompt' : 'prompts'} × {selectedIds.length} {selectedIds.length === 1 ? 'model' : 'models'} × {imagesPerModel} each</span>{/if}
  {#if covered}<span class="covered">{covered} {covered === 1 ? 'model is' : 'models are'} included in your {auth.subscription?.tier === 'unlimited_pro' ? 'Unlimited Pro' : 'Unlimited'} plan.</span>{/if}
  {#if credits}<span>{credits} {credits === 1 ? 'model uses' : 'models use'} credits. You will review the full estimate before submission.</span>{/if}
  {#if unknown}<span>Billing information is loading for {unknown} {unknown === 1 ? 'model' : 'models'}.</span>{/if}
</div>

<style>
  .render-summary { display: grid; gap: 0.25rem; border: 1px solid var(--color-border); background: var(--color-surface); border-radius: 10px; padding: 0.75rem; font-size: 0.8rem; line-height: 1.5; }
  strong { color: var(--color-text); }
  span { color: var(--color-text-muted); }
  .covered { color: #047857; }
</style>
